import { render, staticRenderFns } from "./TabelaProcessosJudiciaisPj.vue?vue&type=template&id=687dfd4f&lang=pug"
import script from "./TabelaProcessosJudiciaisPj.vue?vue&type=script&lang=js"
export * from "./TabelaProcessosJudiciaisPj.vue?vue&type=script&lang=js"
import style0 from "./TabelaProcessosJudiciaisPj.vue?vue&type=style&index=0&id=687dfd4f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports